import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ProjectsComponent } from './projects/projects.component';
import { LoginComponent } from '../login/login.component';
import { AuthGuard } from '@piqet-angular/shared';

const routes: Routes = [
  {
    path: 'dashboard',
    pathMatch: 'full',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'my-profile',
    pathMatch: 'full',
    component: MyProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects',
    // component: ProjectsComponent,
    loadChildren: () => import('./projects/projects.module').then(m => m.ProjectModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin-projects',
    pathMatch: 'full',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'custom',
    loadChildren: () => import('./custom/custom.module').then(m => m.CustomModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'my-organization',
    loadChildren: () =>
      import('./my-organization/my-organization.module').then(m => m.MyOrganizationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'administrator',
    loadChildren: () =>
      import('./administrator/administrator.module').then(m => m.AdministratorModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'organization-report',
    loadChildren: () =>
      import('./organization-report/organization-report.module').then(
        m => m.OrganizationReportModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'report-builder',
    loadChildren: () =>
      import('./report-builder/report-builder.module').then(m => m.ReportBuilderModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: DashboardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class LayoutRoutingModule {}
